import FrenchPage from '../components/lifecycle/FrenchPage';
import FacilitiesHeadFR from '../components/facilities/FacilitiesHeadFR';
import Facilities from './Facilities';

export default function FacilitiesFR() {
  return (
    <>
      <FrenchPage />
      <FacilitiesHeadFR />
      <Facilities />
    </>
  );
}